




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ResponsiveImage extends Vue {
  @Prop(Array) private readonly src!: string[];
  @Prop({ type: String, required: true }) private readonly alt!: string;

  private get srcset(): string {
    return this.src.map((path, index) => `${path} ${index + 1}x`).join(', ');
  }
}
